/** Petrosmart SaaS client billing constants */
export const INVOICE_SOURCES = [
  { value: 'subscription', label: 'Subscription' },
  { value: 'consulting', label: 'Consulting services' },
  { value: 'data_entry', label: 'Data entry services' },
  { value: 'reimbursement', label: 'Reimbursement expenses' },
  { value: 'custom', label: 'Custom / other services' },
  { value: 'other', label: 'Other' },
];

export const SERVICE_TEMPLATES = {
  consulting: { description: 'Consulting services', hsn: '998312', unit: 'Nos', gst: 18 },
  data_entry: { description: 'Data entry services', hsn: '998314', unit: 'Nos', gst: 18 },
  reimbursement: { description: 'Reimbursement of expenses', hsn: '999799', unit: 'Nos', gst: 0 },
};

export const SOURCE_BADGE_CLASS = {
  subscription: 'bg-info',
  consulting: 'bg-primary',
  data_entry: 'bg-secondary',
  reimbursement: 'bg-warning text-dark',
  custom: 'bg-dark',
  other: 'bg-light text-dark border',
};
